import Grid2 from "@mui/material/Grid";
import KpiCard from "./KpiCard";
import { formatCurrency, formatNumber, formatPercent } from "../constants";
import {
  FaEuroSign,
  FaCartShopping,
  FaUsers,
  FaArrowRotateLeft,
  FaBoxesStacked,
  FaHeadset,
} from "react-icons/fa6";
import { orange, blue, teal, red, indigo, purple } from "@mui/material/colors";

interface KpiCardsProps {
  data: any;
  loading: boolean;
}

const KpiCards = ({ data, loading }: KpiCardsProps) => {
  const cards = [
    {
      title: "Total Revenue",
      value: data ? formatCurrency(data.revenue?.total || 0) : "€0",
      subtitle: data
        ? `Tax: ${formatCurrency(data.revenue?.tax || 0)} | Refunded: ${formatCurrency(data.revenue?.refunded || 0)}`
        : "",
      icon: <FaEuroSign />,
      bgColor: orange[50],
      iconColor: orange[700],
    },
    {
      title: "Total Orders",
      value: data ? formatNumber(data.orders?.total || 0) : "0",
      subtitle: data
        ? `Paid: ${formatNumber(data.orders?.byStatus?.paid || 0)} | Failed: ${formatNumber(data.orders?.byStatus?.failed || 0)}`
        : "",
      icon: <FaCartShopping />,
      bgColor: blue[50],
      iconColor: blue[700],
    },
    {
      title: "Total Customers",
      value: data ? formatNumber(data.customers?.total || 0) : "0",
      subtitle: data
        ? `New: ${formatNumber(data.customers?.new || 0)} | Active: ${formatNumber(data.customers?.byStatus?.active || 0)}`
        : "",
      icon: <FaUsers />,
      bgColor: teal[50],
      iconColor: teal[700],
    },
    {
      title: "Refunds",
      value: data ? formatNumber(data.refunds?.total || 0) : "0",
      subtitle: data
        ? `${formatCurrency(data.refunds?.totalAmount || 0)} | Rate: ${formatPercent(data.refunds?.rate || 0)}`
        : "",
      icon: <FaArrowRotateLeft />,
      bgColor: red[50],
      iconColor: red[700],
    },
    {
      title: "Inventory PINs",
      value: data ? formatNumber(data.inventory?.total || 0) : "0",
      subtitle: data
        ? `Available: ${formatNumber(data.inventory?.byStatus?.unassigned || 0)} | Assigned: ${formatNumber(data.inventory?.byStatus?.assigned || 0)}`
        : "",
      icon: <FaBoxesStacked />,
      bgColor: indigo[50],
      iconColor: indigo[700],
    },
    {
      title: "Support Tickets",
      value: data ? formatNumber(data.tickets?.open || 0) : "0",
      subtitle: "Open tickets",
      icon: <FaHeadset />,
      bgColor: purple[50],
      iconColor: purple[700],
    },
  ];

  return (
    <Grid2 container spacing={2}>
      {cards.map((card, index) => (
        <Grid2 key={index} size={{ xs: 12, sm: 6, md: 4 }}>
          <KpiCard {...card} loading={loading} />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default KpiCards;
